// action type strings
import * as actionTypes from '../../actionTypes';


export function clearContactInContactWorksheet() {
  return {
    type: actionTypes.CLEAR_CONTACT_IN_CONTACT_WORKSHEET,
  };
}

export function updateContactInContactWorksheet({contact}) {
  return {
    type: actionTypes.UPDATE_CONTACT_IN_CONTACT_WORKSHEET,
    contact
  };
}

export function updateContact({contact}) {
  return {
    type: actionTypes.UPDATE_CONTACT,
    contact
  };
}

export function updateContactProfile(contact) {
  console.warn(`This function is DEPRECATED please use updateProfile, updateCompany instead.`);
  return {
    type: actionTypes.UPDATE_CONTACT_PROFILE,
    contact
  };
}

export function updateProfile(profile) {
  return {
    type: actionTypes.UPDATE_PROFILE,
    profile
  };
}



// WEBPACK FOOTER //
// ./shared/redux/actionCreators/sync/contacts.js